import { MutableRefObject, useCallback } from "react";
import { LoadingOverlay } from "@sunrun/experience-ui-components";
import { DashboardPage } from "@sunrun/sales-experience-shared";
import { useDashboardAdapter } from "adapters/dashboard";
import { postMessage } from "adapters/helpers";
import { IFrame } from "components/atoms/IFrame";
import { useUpdateRetailStoreLocation } from "helpers/retailStoreLocation";
import { appendQuery } from "helpers/url";
import { Message } from "messages";
import { useAISalesAppJwt } from "providers/AISalesAppJwt";

const DashboardIFrame = ({ page }: { page: DashboardPage }) => {
  useUpdateRetailStoreLocation();

  const { jwtResponse, isLoading = true } = useAISalesAppJwt();
  let queryString = `jwt=${jwtResponse?.jwt}&email=${jwtResponse?.email}`;
  if (jwtResponse?.employeeId != null) {
    queryString += `&employeeId=${jwtResponse.employeeId}`;
  }

  const messageHandler = useCallback(
    (ref: React.MutableRefObject<HTMLIFrameElement | null>) =>
      (message: Message | undefined) => {
        if (!message) {
          return;
        }
        if (message.type === "EVENT:READY") {
          postMessage(
            {
              type: "EVENT:GET_PARENT_RETAIL_STORE_DATA",
              source: "Container",
              payload: {
                retailStoreLocation:
                  localStorage.getItem("retailStoreLocation") || "",
                retailStoreName: localStorage.getItem("retailStoreName") || "",
                channelType: localStorage.getItem("channelType") || "",
              },
            },
            ref as MutableRefObject<HTMLIFrameElement>
          );
        }

        return message;
      },
    []
  );
  const { basePath, ref, src, title } = useDashboardAdapter(
    page,
    messageHandler
  );

  if (isLoading) {
    return <LoadingOverlay message="Loading..." />;
  }

  const dashboardBasePath = appendQuery(basePath, queryString);
  const dashboardSrc = appendQuery(src, queryString);

  return (
    <IFrame
      basePath={dashboardBasePath}
      ref={ref}
      title={title}
      src={dashboardSrc}
    ></IFrame>
  );
};

export { DashboardIFrame };
